import {
  ChakraBox,
  ChakraHStack,
  FAIconName,
  FireflyButton,
  ModalV2,
  Text,
} from '@equip.health/ui';

interface ChangeHostConfirmationModalProps {
  groupClassExternalId?: string;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  userId?: string;
}

const ChangeHostConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
}: ChangeHostConfirmationModalProps) => {
  const TOP_LEVEL_ID = 'group-class-Confirmation-modal';
  return (
    <ModalV2
      footerContent={
        <ChakraHStack justifyContent="space-between" width="100%">
          <FireflyButton
            id={`${TOP_LEVEL_ID}__cancel-button`}
            leftIcon={FAIconName.timesRegular}
            onClick={onClose}
            variant="secondary"
          >
            Cancel
          </FireflyButton>
          <FireflyButton
            id={`${TOP_LEVEL_ID}__Changehost-button`}
            leftIcon={FAIconName.checkRegular}
            onClick={onConfirm}
          >
            Change host
          </FireflyButton>
        </ChakraHStack>
      }
      id={TOP_LEVEL_ID}
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      title="Change host"
    >
      <ChakraBox>
        <Text id={`${TOP_LEVEL_ID}__warning-text`} variant="body">
          Are you sure you want to change the host of this appointment? Changing
          the host will refresh availability based on the new host's calendar.
        </Text>
      </ChakraBox>
    </ModalV2>
  );
};

export default ChangeHostConfirmationModal;
